module.exports = __webpack_public_path__ + "img/cases-brand-zedriv-3.b0308f9c.png";